<template>
  <div>

    <section class="feature-section section-odd">
      <div class="container">
        <div class="row ">

          <div class="col-lg-6 text-left">
            <div class="testimonial-element mt-30">
              <a href="#" class="pull-left">
                <img alt="image" class="rounded-circle" src="images/head-shots/tom-quigley-sm.png">
              </a>
              <div class="media-body ">
                <p class="testimonial-quote mt-0 m-l-md">"Skippr has saved us hundreds of hours of engineering time
                  and thousands of dollars every month. It's a no brainer."</p>
                <em class="m-l-md">- <strong>Tom Quigley</strong> (DevOps Engineer)</em>
                <div class="actions m-l-md mt-10">
                  <a href="https://www.linkedin.com/in/tom-quigley-46301b248">
                    <font-awesome-icon :icon="['fab', 'linkedin']" />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div class="col-lg-6 text-right">
            <h2 class="mb-0">100x Faster.</h2>
            <h2 class="mt-20">90% Cost Reduction.</h2>
<!--            <p>Learn how Skippr drives <strong>more value</strong> for <strong>less engineering time</strong> and infrastructure $'s.</p>-->

          </div>


        </div>


        <div class="row ">

          <div class="col-lg-12 text-right">
            <p class="m-l-xl">Turn your hardest data integration challenges into low hanging fruit.</p>
          </div>
        </div>

      </div>
    </section>

  </div>
</template>

<script>
export default {
  name: 'ValueClaim',
  props: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
